<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <InfoCard :infoData="this.infoDetails" :loading="this.loading" />
      <div class="row">
        <div class="col-lg-12">
          <div class="card" id="orderList">
            <div class="card-header border-0">
              <div class="d-flex align-items-center" style="text-align: left">
                <h5 class="card-title mb-0 flex-grow-1">All Settlements</h5>
                <div class="flex-shrink-0">
                  <button
                    type="button"
                    class="btn btn-info"
                    @click="expSetNow()"
                    fdprocessedid="1yahzs"
                  >
                    <i class="ri-download-line align-bottom me-1"></i> Export
                  </button>
                </div>
              </div>
            </div>
            <div
              class="card-body border border-dashed border-end-0 border-start-0"
            >
              <form>
                <div class="row g-3">
                  <div class="col-xxl-3 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        class="form-control search"
                        placeholder="Search"
                        v-model="search_key"
                        @input="fetchList(1)"
                      />

                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>
                  <div class="col-xxl-1 col-sm-2">
                    <Filteroption
                      :filterOptions="filterByOptions"
                      :initialSelected="'all'"
                      @apply="handleApplyFilters"
                    />
                  </div>
                  <div
                    class="col-xxl-2 col-sm-4"
                    v-if="ldata != null && ldata.role === 'superadmin'"
                  >
                    <div>
                      <select
                        class="form-control"
                        name="choices-single-default"
                        v-model="search_status"
                        @change="fetchList(1)"
                      >
                        <option
                          v-for="(option, index) in statusSortOptions"
                          :key="index"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div
                    class="col-xxl-2 col-sm-4"
                    v-if="ldata != null && ldata.role === 'superadmin'"
                  >
                    <div>
                      <select
                        class="form-control"
                        name="choices-single-default"
                        v-model="search_sort"
                        @change="fetchList(1)"
                      >
                        <option
                          v-for="(option, index) in sortOptions"
                          :key="index"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="card-body pt-0">
              <div>
                <br />
                <br />
                <div class="table-responsive table-card mb-1">
                  <div class="noresult" v-if="loading">
                    <rb-loading-table />
                  </div>
                  <div v-else>
                    <rb-data-table
                      :ldata="this.ldata"
                      :headers="headers"
                      :tableData="formattedSettelments"
                      @edit="editSettlement"
                      @delete="deleteSettlementRecord"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-end" v-if="!loading">
                  <div class="me-3">
                    <select
                      class="form-select w-auto"
                      v-model="limitProxy"
                      @change="fetchList(1)"
                    >
                      <template
                        v-for="(role, index) in paginationOptions"
                        :key="index"
                      >
                        <option :value="role">{{ role }}</option>
                      </template>
                    </select>
                  </div>
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="fetchList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="settlements.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="settlements.length >= limit"
                          class="page"
                          href="javascript:void(0)"
                          @click="fetchList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="settlements.length >= limit"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="fetchList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { settlementHeaders } from "@/constants/headers";
import { settlementInfoDetails } from "@/constants/infodetails";
import { getAllSettlements } from "@/apis/settlement";
import listMixin from "@/mixins/listMixin";
import {
  settlementStatusSortOptions,
  settlementSortOptions,
} from "@/constants/sort";
import { settlementFilterByOptions } from "@/constants/filter";
import Filteroption from "@/components/filter/filteroption.vue";

export default {
  name: "settlementList",

  mixins: [listMixin],
  components: { Filteroption },

  data() {
    return {
      settlements: [],
      search_key: "",
      search_status: "pending",
      search_sort: "",

      filterByOptions: settlementFilterByOptions,
      statusSortOptions: settlementStatusSortOptions,
      sortOptions: settlementSortOptions,
      infoDetails: settlementInfoDetails,
      headers: settlementHeaders,
    };
  },

  methods: {
    expSetNow() {
      const fields = [
        "operatorName",
        "busNumber",
        "travelsName",
        "mobile",
        "accountNumber",
        "bankReference",
        "amount",
        "status",
      ];
      this.$exportCsv(this.formattedSettelments, "Settlements.csv", fields);
    },

    async fetchList(pageNo) {
      const response = await this.fetch(pageNo, getAllSettlements, {
        settled_status: this.search_status,
        sort_by: this.search_sort,
        filterBy: this.selectedFilterValue,
        value: this.search_key,
      });

      this.settlements = response.data;

      this.infoDetails[0].count =
        response?.total_amount_settled ||
        response?.response?.total_amount_settled || 0;
      this.infoDetails[1].count =
        response?.total_settlement || response?.response?.total_settlement || 0;
      this.infoDetails[2].count =
        response?.failed_settlements ||
        response?.response?.failed_settlements ||
        0;

      this.stopLoading();
    },

    async editSettlement(value) {
      const settlementData = this.settlements.find((val) => {
        return val.settlement_id === value.spec_id;
      });

      this.storeEditData(settlementData);
      this.$router.push("/settlements/add");
    },
  },

  computed: {
    formattedSettelments() {
      return this.settlements.map((settlement) => ({
        id: settlement.id,
        spec_id: settlement.settlement_id,
        operatorID: settlement.operator_id,
        operatorName: settlement.operator_name,
        mobile: settlement.phone_number || "N/A",
        busNumber: settlement.reg_no || "N/A",
        travelsName: settlement.travels_name || "N/A",
        accountNumber: settlement.bank.account_number || "N/A",
        bankReference: settlement.bank_reference_number || "-",
        amount: settlement.amount,
        status: settlement.settled_status ? "Settled" : "Pending",
      }));
    },
  },
};
</script>
